<template>
  <!-- ========================= 底部 ========================= -->
  <div>
    <div id="footer">
      <div class="container">
        <ul class="footer_top">
          <li @click="goHome">首页</li>
          <li @click="goUrl('/')">关于我们</li>
          <li @click="goUrl('/serve')">产品与服务</li>
          <li @click="goUrl('/serve-serveshipper')">货主发货</li>
          <li @click="goUrl('/serve-servedriver')">司机接单</li>
          <li @click="goUrl('/serve-download')">产品下载</li>
          <li @click="goUrl('/newslist')">新闻中心</li>
          <li style="border: none" @click="goUrl('/business')">业务合作</li>
        </ul>
        <div class="footer_box">
          <div class="footer_box_item">
            <h3 class="footer_box_item_title">联系我们</h3>
            <div class="footer_box_item_box">
              <div class="footer_box_item_box_item">联系电话：4001-368-360</div>
              <div class="footer_box_item_box_item">邮箱：hmmwl56@163.com</div>
              <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/aboutus/logo@3x.png" alt="货满满物流">
            </div>
          </div>
          <div class="footer_box_item" style="margin-left: 60px;width: 368px;">
            <h3 class="footer_box_item_title">公司地址</h3>
            <div class="footer_box_item_box">
              <div class="footer_box_item_box_item p30bs">公司名称：山东云水网运物流有限公司</div>
              <div class="footer_box_item_box_item p30bs">公司地址：山东省聊城市</div>
              <div class="footer_box_item_box_item p30bs">分公司地址：山东省济南市历城区</div>
            </div>
          </div>
          <div class="footer_box_item" style="margin-left: 60px; flex: 1">
            <h3 class="footer_box_item_title">关注我们</h3>
            <div class="footer_box_item_box1">
              <div class="footer_box_item_box1_item">
                <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/aboutus/gzh.jpg" alt="货满满公众号">
                <div>
                  <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/aboutus/wx.png" alt="">
                  <span>公众号</span>
                </div>
              </div>
              <div class="footer_box_item_box1_item">
                <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/aboutus/wxminCode.jpg" alt="货满满货主端小程序">
                <div>
                  <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/aboutus/wxmini.png" alt="">
                  <span>小程序</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="bot">
      <p>
        Copyright © 2007-2020 山东云水网运物流有限公司 版权所有（鲁ICP备20022169号-1）
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37152602000210" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;" target="_blank">公安备案号 37152602000210号</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomFooter",
  methods: {
    /**
     * @description: 跳转路径
     * @author: 书童
     */
    goUrl(url) {
      this.$router.push({
        path: url
      })
    },
    /**
     * @description: 跳转首页
     * @author: 书童
     */
    goHome() {
      window.location.href = 'http://hmmwuliu.net/index.html'
    }
  }
}
</script>

<style scoped>
#footer{
  height: 528px;
  width: 100%;
  background: #333333;
}
.container{
  width: 1200px;
  margin: 0 auto;
}
#footer .footer_top{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 122px;
  border-bottom: 2px solid #706A6A;
  box-sizing: border-box;
}
#footer .footer_top li{
  height: 20px;
  font-size: 16px;
  font-family: Inter, Inter-Regular;
  font-weight: 400;
  color: #d9d9d9;
  line-height: 20px;
  padding: 0 20px;
  border-right: 2px solid #706A6A;
  cursor: pointer;
}
#footer .footer_top li:hover{
  color: rgba(217,217,217,0.50);
}
#footer .footer_box{
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 346px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
}
#footer .footer_box .footer_box_item{
  width: 336px;
  height: 175px;
}
#footer .footer_box .footer_box_item .footer_box_item_title{
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: LEFT;
  color: #d9d9d9;
  line-height: 34px;
  margin: 50px 0 27px 0;
}
#footer .footer_box .footer_box_item .footer_box_item_box{
  width: 100%;
  border-right: 1px solid #706A6A;
  padding-right: 60px;
  box-sizing: border-box;
}
#footer .footer_box .footer_box_item .footer_box_item_box .footer_box_item_box_item{
  width: 100%;
  height: 45px;
  border: 1px solid #706a6a;
  border-radius: 2px;
  text-align: center;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Inter, Inter-Regular;
  font-weight: 400;
  color: #d9d9d9;
  line-height: 43px;
  margin-bottom: 20px;
}
#footer .footer_box .footer_box_item .footer_box_item_box .p30bs{
  padding: 0 30px;
  box-sizing: border-box;
  text-align: left;
}
#footer .footer_box .footer_box_item .footer_box_item_box img{
  display: block;
  width: 80px;
  height: 38px;
  margin-left: 20px;
  margin-top: 25px;
}
#footer .footer_box .footer_box_item .footer_box_item_box1{
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 175px;
}
#footer .footer_box .footer_box_item .footer_box_item_box1 .footer_box_item_box1_item{
  width: 130px;
  height: 100%;
}
#footer .footer_box .footer_box_item .footer_box_item_box1 .footer_box_item_box1_item>img{
  display: block;
  width: 130px;
  height: 130px;
}
#footer .footer_box .footer_box_item .footer_box_item_box1 .footer_box_item_box1_item div{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: LEFT;
  color: #d9d9d9;
}
#footer .footer_box .footer_box_item .footer_box_item_box1 .footer_box_item_box1_item div>img{
  display: block;
  width: 22px;
  height: 22px;
  margin-right: 5px;
}
#bot{
  height: 60px;
  width: 100%;
  background-color: #1D1D1D;
  text-align: center;
  line-height: 60px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #ffffff;
}
</style>